import { useNavigate } from "react-router-dom";
import { Minus, Plus, Trash2, ShoppingBag } from "lucide-react";
import { Sheet, SheetContent, SheetHeader, SheetTitle } from "@/components/ui/sheet";
import { Button } from "@/components/ui/button";
import { useCart } from "@/lib/cart";
import { formatRp, imgUrl } from "@/lib/api";
import { ShippingEstimate } from "@/components/shop/ShippingEstimate";

export const CartLine = ({ item }) => {
  const { setQty, remove } = useCart();
  return (
    <div className="flex gap-3 py-3" data-testid={`cart-item-${item.key}`}>
      <img src={imgUrl(item.image)} alt={item.name} className="h-16 w-16 rounded-md object-cover" />
      <div className="flex-1 min-w-0">
        <p className="text-sm font-medium leading-snug">{item.name}</p>
        {Object.keys(item.variant || {}).length > 0 && (
          <p className="text-xs text-stone-500">{Object.entries(item.variant).map(([k, v]) => `${k}: ${v}`).join(" · ")}</p>
        )}
        <div className="mt-2 flex items-center gap-2">
          <button data-testid="cart-item-decrease" onClick={() => setQty(item.key, item.qty - 1)} className="rounded border border-stone-200 p-1 hover:bg-stone-100"><Minus className="h-3 w-3" /></button>
          <span className="tnum w-6 text-center text-sm" data-testid="cart-item-qty">{item.qty}</span>
          <button data-testid="cart-item-increase" onClick={() => setQty(item.key, item.qty + 1)} className="rounded border border-stone-200 p-1 hover:bg-stone-100"><Plus className="h-3 w-3" /></button>
          <button data-testid="cart-item-remove" onClick={() => remove(item.key)} className="ml-auto rounded p-1 text-stone-400 hover:text-red-700"><Trash2 className="h-4 w-4" /></button>
        </div>
      </div>
      <p className="tnum text-sm font-medium">{formatRp(item.price * item.qty)}</p>
    </div>
  );
};

export const CartSheet = () => {
  const { items, open, setOpen, subtotal } = useCart();
  const navigate = useNavigate();
  return (
    <Sheet open={open} onOpenChange={setOpen}>
      <SheetContent className="flex w-full flex-col sm:max-w-md" data-testid="cart-sheet">
        <SheetHeader><SheetTitle>Keranjang Belanja</SheetTitle></SheetHeader>
        {items.length === 0 ? (
          <div className="flex flex-1 flex-col items-center justify-center gap-3 text-center text-stone-500" data-testid="cart-empty">
            <ShoppingBag className="h-10 w-10 text-stone-300" />
            <p className="text-sm">Keranjang masih kosong. Yuk pilih karya handmade favoritmu.</p>
          </div>
        ) : (
          <>
            <div className="flex-1 overflow-y-auto pb-4">
              <div className="divide-y divide-stone-100">{items.map((i) => <CartLine key={i.key} item={i} />)}</div>
              <ShippingEstimate className="mt-4" items={items} subtitle="seluruh isi keranjang" note="Perkiraan untuk seluruh isi keranjang. Ongkir final dihitung di checkout." />
            </div>
            <div className="border-t border-stone-200 pt-4">
              <div className="mb-3 flex justify-between text-sm"><span>Subtotal</span><span className="tnum font-semibold" data-testid="cart-subtotal">{formatRp(subtotal)}</span></div>
              <Button data-testid="cart-checkout-button" className="h-11 w-full" onClick={() => { setOpen(false); navigate("/checkout"); }}>Lanjut ke Checkout</Button>
            </div>
          </>
        )}
      </SheetContent>
    </Sheet>
  );
};
